import { Reorder, useMotionValue } from 'framer-motion';
import { IoReorderFour } from 'react-icons/io5';
import { ReorderItem } from '../../../types/common';

const ReorderCard = ({ item, index }: { item: ReorderItem; index: number }) => {
  // integration of framer-motion hooks here
  const y = useMotionValue(0);

  // rendering reorder card item here
  return (
    <Reorder.Item
      className='flex items-center justify-between bg-base-white text-legal-dark-blue font-semibold cursor-pointer rounded-lg p-3 border-2 border-legal-dark-blue hover:text-gray-400 hover:border-gray-400 shadow-academia-sm'
      value={item}
      id={item.id.toString()}
      style={{ y }}
    >
      <div>
        <span className='text-base-orange'>{index + 1}. </span>
        <span>{item.name}</span>
      </div>
      <IoReorderFour className='size-5' />
    </Reorder.Item>
  );
};

export default ReorderCard;
